module.exports = [
	{
		"componentChunkName": "page-component---src-templates-tags-js",
		"jsonName": "tags.json",
		"path": "/tags"
	},
	{
		"componentChunkName": "page-component---src-templates-tags-js",
		"jsonName": "tags-swift.json",
		"path": "/tags/swift"
	},
	{
		"componentChunkName": "page-component---src-templates-tags-js",
		"jsonName": "tags-c.json",
		"path": "/tags/C"
	},
	{
		"componentChunkName": "page-component---src-templates-tags-js",
		"jsonName": "tags-minutes.json",
		"path": "/tags/minutes"
	},
	{
		"componentChunkName": "page-component---src-templates-tags-js",
		"jsonName": "tags-simple.json",
		"path": "/tags/simple"
	},
	{
		"componentChunkName": "page-component---src-templates-tags-js",
		"jsonName": "tags-beginner.json",
		"path": "/tags/beginner"
	},
	{
		"componentChunkName": "page-component---src-templates-tags-js",
		"jsonName": "tags-programming.json",
		"path": "/tags/programming"
	},
	{
		"componentChunkName": "page-component---src-templates-tags-js",
		"jsonName": "tags-coding.json",
		"path": "/tags/coding"
	},
	{
		"componentChunkName": "page-component---src-templates-tags-js",
		"jsonName": "tags-coder.json",
		"path": "/tags/coder"
	},
	{
		"componentChunkName": "page-component---src-templates-tags-js",
		"jsonName": "tags-if.json",
		"path": "/tags/if"
	},
	{
		"componentChunkName": "page-component---src-templates-tags-js",
		"jsonName": "tags-if-let.json",
		"path": "/tags/if let"
	},
	{
		"componentChunkName": "page-component---src-templates-tags-js",
		"jsonName": "tags-guard.json",
		"path": "/tags/guard"
	},
	{
		"componentChunkName": "page-component---src-templates-tags-js",
		"jsonName": "tags-decision.json",
		"path": "/tags/decision"
	},
	{
		"componentChunkName": "page-component---src-templates-tags-js",
		"jsonName": "tags-else.json",
		"path": "/tags/else"
	},
	{
		"componentChunkName": "page-component---src-templates-tags-js",
		"jsonName": "tags-hello-world.json",
		"path": "/tags/hello world\""
	},
	{
		"componentChunkName": "page-component---src-templates-tags-js",
		"jsonName": "tags-starting.json",
		"path": "/tags/starting"
	},
	{
		"componentChunkName": "page-component---src-templates-tags-js",
		"jsonName": "tags-loops.json",
		"path": "/tags/loops"
	},
	{
		"componentChunkName": "page-component---src-templates-tags-js",
		"jsonName": "tags-simple-logic.json",
		"path": "/tags/simple logic"
	},
	{
		"componentChunkName": "page-component---src-templates-tags-js",
		"jsonName": "tags-for-loop.json",
		"path": "/tags/for loop"
	},
	{
		"componentChunkName": "page-component---src-templates-tags-js",
		"jsonName": "tags-for.json",
		"path": "/tags/for"
	},
	{
		"componentChunkName": "page-component---src-templates-tags-js",
		"jsonName": "tags-foreach.json",
		"path": "/tags/foreach"
	},
	{
		"componentChunkName": "page-component---src-templates-tags-js",
		"jsonName": "tags-itterate.json",
		"path": "/tags/itterate"
	},
	{
		"componentChunkName": "page-component---src-templates-tags-js",
		"jsonName": "tags-interview-question.json",
		"path": "/tags/interview question"
	},
	{
		"componentChunkName": "page-component---src-templates-tags-js",
		"jsonName": "tags-fizz-buzz.json",
		"path": "/tags/fizz buzz"
	},
	{
		"componentChunkName": "page-component---src-templates-tags-js",
		"jsonName": "tags-fizz.json",
		"path": "/tags/fizz"
	},
	{
		"componentChunkName": "page-component---src-templates-tags-js",
		"jsonName": "tags-buzz.json",
		"path": "/tags/buzz"
	},
	{
		"componentChunkName": "page-component---src-templates-tags-js",
		"jsonName": "tags-fizzbuzz.json",
		"path": "/tags/fizzbuzz"
	},
	{
		"componentChunkName": "page-component---src-templates-blog-post-js",
		"jsonName": "swiftdefer-html.json",
		"path": "/swiftdefer.html"
	},
	{
		"componentChunkName": "page-component---src-templates-blog-post-js",
		"jsonName": "writeright-html.json",
		"path": "/writeright.html"
	},
	{
		"componentChunkName": "page-component---src-templates-blog-post-js",
		"jsonName": "swiftletvar-html.json",
		"path": "/swiftletvar.html"
	},
	{
		"componentChunkName": "page-component---src-templates-blog-post-js",
		"jsonName": "basicmath-html.json",
		"path": "/basicmath.html"
	},
	{
		"componentChunkName": "page-component---src-templates-blog-post-js",
		"jsonName": "swiftguard-html.json",
		"path": "/swiftguard.html"
	},
	{
		"componentChunkName": "page-component---src-templates-blog-post-js",
		"jsonName": "swiftif-html.json",
		"path": "/swiftif.html"
	},
	{
		"componentChunkName": "page-component---src-templates-blog-post-js",
		"jsonName": "swiftforloop-html.json",
		"path": "/swiftforloop.html"
	},
	{
		"componentChunkName": "page-component---src-templates-blog-post-js",
		"jsonName": "fizzbuzz-html.json",
		"path": "/fizzbuzz.html"
	},
	{
		"componentChunkName": "page-component---src-templates-blog-post-js",
		"jsonName": "helloworld-html.json",
		"path": "/helloworld.html"
	},
	{
		"componentChunkName": "page-component---src-pages-404-js",
		"jsonName": "404.json",
		"path": "/404/"
	},
	{
		"componentChunkName": "page-component---src-pages-index-js",
		"jsonName": "index.json",
		"path": "/"
	},
	{
		"componentChunkName": "page-component---src-pages-404-js",
		"jsonName": "404-html.json",
		"path": "/404.html"
	}
];


//////////////////
// WEBPACK FOOTER
// ./.cache/pages.json
// module id = ./.cache/pages.json
// module chunks = 45